<template>
  <div>
    123
  </div>
</template>
<script>
  export default {
    name: 'authorization',
    data(){
      return{
        code:"",
        state:"",
        extenNum:"",
        parms:[]
      }
    },
    methods:{
      isAjax:async function(){
        await this.$axios.post('/api/b_0000002_sc',{
          "c":this.code,
          "userid":this.state
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Success"){
            var json = response.data;
            if(typeof (this.parms[1]) == "undefined"){
              this.parms[1] = "p:xxt_index";
            }
            location.href= json.url+"app/index_terminal.html?openid="+(json.openid?json.openid:"")+"&userid="+this.state+"&unionid="+(json.unionid?json.unionid:"")+"#"+this.parms[1];
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
            window.close();
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
            window.close();
          }

        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      GetUrlParms(){
        var args = new Object();
        var query = location.search.substring(1); //获取查询串
        var pairs = query.split("&"); //在逗号处断开
        for (var i = 0; i < pairs.length; i++) {
          var pos = pairs[i].indexOf('='); //查找name=value
          if (pos == -1) continue; //如果没有找到就跳过
          var argname = pairs[i].substring(0, pos); //提取name
          var value = pairs[i].substring(pos + 1); //提取value
          args[argname] = value; //存为属性
        }
        return args;
      }
    },
    mounted:function () {
      document.getElementsByTagName("title")[0].innerText = '授权中';
      var meta = document.createElement('meta');
      meta.content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, user-scalable=no";
      meta.name="viewport";
      document.getElementsByTagName('head')[0].appendChild(meta);
      var args=this.GetUrlParms();
      var code = args["code"];
      var state = args["state"];
      var extenNum = args["extenNum"];
      if(code == undefined && args["from"]!=""){
        var _a = location.href;
        var _b = (_a.split('#')[1]).split('&')[1];
        var _c = _b.split('=')[1];
        code = _c;
      }
      this.parms = (location.href).split('#');
      this.code = code;
      this.state = state;
      this.extenNum = extenNum;
      /*if (document.referrer.length > 0) {
        this.url = document.referrer;
      }
      try {
        if (ref.length == 0 && opener.location.href.length > 0) {
          this.url = opener.location.href;
        }
      } catch (e) {

      }*/
      this.isAjax();
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/authorization/authorization.vue